import { NotificationType } from 'src_server/trpc/types/accountModel/accountResponse';

const MARKERS_OF_HARM_NAME_REGEX = /^moh-(\d+)$/i;

export const extractMarkersOfHarmTriggerId = (notificationType: NotificationType): number | null => {
    const notificationName = notificationType.trim();
    const match = notificationName.match(MARKERS_OF_HARM_NAME_REGEX);

    if (match === null) {
        return null;
    }

    return Number.parseInt(match[1] ?? '', 10);
};
